import React, { useState, useRef } from 'react';
import { SearchIcon, ClockIcon, PlusIcon, SendIcon, MicIcon, UserIcon, AlertTriangleIcon, InfoIcon, ShieldCheckIcon } from 'lucide-react';
import { Button } from '../components/common/Button';
interface PassOn {
  id: string;
  author: string;
  role: string;
  timestamp: string;
  type: 'alert' | 'info' | 'update';
  content: string;
}
const passOnsData: PassOn[] = [{
  id: '1',
  author: 'Sgt. Miller',
  role: 'Shift Supervisor',
  timestamp: '08:30',
  type: 'alert',
  content: 'BOLO: Blue 2018 Honda Civic, partial plate "K92", linked to multiple vehicle prowls in Sector 4. Use caution when approaching.'
}, {
  id: '2',
  author: 'Officer Chen',
  role: 'Patrol',
  timestamp: '09:15',
  type: 'info',
  content: 'The construction on Main St and 5th is causing significant traffic delays. Recommend rerouting non-emergency responses to 4th Ave.'
}, {
  id: '3',
  author: 'Det. Rodriguez',
  role: 'Investigations',
  timestamp: '10:45',
  type: 'update',
  content: 'Suspect from the 1104 Main St incident has been identified. Warrant is being processed. See incident file for details.'
}, {
  id: '4',
  author: 'Sgt. Miller',
  role: 'Shift Supervisor',
  timestamp: '11:20',
  type: 'info',
  content: 'Reminder: Mandatory briefing for the upcoming community event is scheduled for 14:00 in the main conference room.'
}];
const PassOnCard = ({
  item
}: {
  item: PassOn;
}) => {
  const getIcon = () => {
    switch (item.type) {
      case 'alert':
        return <AlertTriangleIcon size={14} className="text-red-500" data-id="element-443" />;
      case 'update':
        return <ShieldCheckIcon size={14} className="text-green-500" data-id="element-444" />;
      default:
        return <InfoIcon size={14} className="text-[#4a90e2]" data-id="element-445" />;
    }
  };
  return <div className="group relative p-7 py-6 min-h-[128px] rounded-2xl border border-white/5 bg-[#151A22]/40 hover:border-white/10 hover:bg-[#151A22]/60 transition-all duration-200" data-id="element-446">
      <div className="flex justify-between items-start mb-4" data-id="element-447">
        <div className="flex items-center gap-4" data-id="element-448">
          <div className="flex items-center gap-2" data-id="element-449">
            <span className="text-sm font-medium text-[#f59e0b]" data-id="element-450">
              {item.timestamp}
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-451">
            <span className="text-xs font-bold text-[#f59e0b] uppercase tracking-widest" data-id="element-452">
              {item.author}
            </span>
            <span className="text-xs font-bold text-[#444444] uppercase tracking-widest" data-id="element-453">
              |
            </span>
            <span className="text-xs font-bold text-[#888888] uppercase tracking-widest" data-id="element-454">
              {item.role}
            </span>
          </div>
        </div>
        <div className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider flex items-center gap-1.5 ${item.type === 'alert' ? 'bg-red-500/10 text-red-500' : item.type === 'update' ? 'bg-green-500/10 text-green-500' : 'bg-[#4a90e2]/10 text-[#4a90e2]'}`} data-id="element-455">
          {getIcon()}
          {item.type}
        </div>
      </div>

      <p className="text-lg text-[#e0e0e0] leading-relaxed font-medium" data-id="element-456">
        {item.content}
      </p>
    </div>;
};
export const PassOns = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [message, setMessage] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const filteredPassOns = passOnsData.filter(item => item.content.toLowerCase().includes(searchQuery.toLowerCase()) || item.author.toLowerCase().includes(searchQuery.toLowerCase()));
  return <main className="flex-grow flex flex-col h-full min-h-0 overflow-hidden relative bg-[#0a1120]" data-id="element-457">
      <div className="flex-grow flex flex-col min-h-0 overflow-hidden" data-id="element-458">
        {/* Sticky Header */}
        <div className="flex-shrink-0 p-8 border-b border-white/5 bg-[#0a1120]/80 backdrop-blur-md z-20" data-id="element-459">
          <div className="max-w-[1000px] mx-auto flex justify-between items-end" data-id="element-460">
            <div data-id="element-461">
              <div className="flex items-center gap-2 mb-3" data-id="element-462">
                <div className="w-2 h-2 rounded-full bg-[#f59e0b]" data-id="element-463" />
                <span className="text-xs font-bold text-[#f59e0b] uppercase tracking-[0.2em]" data-id="element-464">
                  {filteredPassOns.length.toString().padStart(2, '0')} ACTIVE
                  PASS ONS FOR THIS SHIFT
                </span>
              </div>
              <h1 className="text-3xl font-bold text-white tracking-tight" data-id="element-465">
                Pass Ons
              </h1>
            </div>
            <div className="flex items-center gap-4" data-id="element-466">
              <div className="relative w-64" data-id="element-467">
                <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-[#666666]" size={16} data-id="element-468" />
                <input type="text" placeholder="Search" className="w-full bg-[#151A22]/50 border border-white/5 rounded-lg py-2 pl-10 pr-4 text-sm text-[#e0e0e0] focus:outline-none focus:border-white/10 transition-colors placeholder:text-[#444444]" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-469" />
              </div>
            </div>
          </div>
        </div>

        <div className="flex-grow overflow-y-auto custom-scrollbar" data-id="element-470">
          <div className="p-8 max-w-[1000px] mx-auto w-full flex flex-col min-h-full" data-id="element-471">
            <div className="mb-8 p-6 rounded-2xl bg-[#1e293b]/50 border border-[#4a90e2]/30 shadow-lg" data-id="element-472">
              <div className="flex items-center gap-2 mb-4" data-id="element-473">
                <h2 className="text-sm font-bold text-white uppercase tracking-widest" data-id="element-474">
                  Previous shift summary
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-475">
                <div className="space-y-3" data-id="element-476">
                  <h3 className="text-xs font-bold text-[#666666] uppercase tracking-wider" data-id="element-477">
                    Critical Alerts
                  </h3>
                  <ul className="space-y-2" data-id="element-478">
                    <li className="text-sm text-[#e0e0e0] flex gap-2" data-id="element-479">
                      <span className="text-red-500" data-id="element-480">•</span>
                      BOLO active for Sector 4 vehicle prowls (Blue Honda
                      Civic).
                    </li>
                    <li className="text-sm text-[#e0e0e0] flex gap-2" data-id="element-481">
                      <span className="text-red-500" data-id="element-482">•</span>
                      Main St & 5th construction causing major delays; use 4th
                      Ave.
                    </li>
                  </ul>
                </div>
                <div className="space-y-3" data-id="element-483">
                  <h3 className="text-xs font-bold text-[#666666] uppercase tracking-wider" data-id="element-484">
                    Operational Updates
                  </h3>
                  <ul className="space-y-2" data-id="element-485">
                    <li className="text-sm text-[#e0e0e0] flex gap-2" data-id="element-486">
                      <span className="text-green-500" data-id="element-487">•</span>
                      Suspect identified for 1104 Main St; warrant in progress.
                    </li>
                    <li className="text-sm text-[#e0e0e0] flex gap-2" data-id="element-488">
                      <span className="text-[#4a90e2]" data-id="element-489">•</span>
                      Mandatory community event briefing at 14:00 today.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex-grow" data-id="element-490">
              <div className="space-y-6 py-4" data-id="element-491">
                {filteredPassOns.map(item => <div key={item.id} className="relative group/note" data-id="element-492">
                    <PassOnCard item={item} data-id="element-493" />
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        {/* Sticky Chat Footer */}
        <div className="p-8 pt-4 border-t border-white/5 bg-[#0a1120]/80 backdrop-blur-md" data-id="element-494">
          <div className="max-w-[1000px] mx-auto flex items-center gap-4 h-16" data-id="element-495">
            <div className="flex-grow bg-[#151A22]/50 border border-white/5 rounded-2xl px-5 flex items-center h-full" data-id="element-496">
              <div className="flex items-center gap-4 w-full" data-id="element-497">
                <button className="text-[#888888] hover:text-[#e0e0e0] transition-colors" title="Attach file" data-id="element-498">
                  <PlusIcon size={22} data-id="element-499" />
                </button>
                <textarea ref={textareaRef} className="flex-grow bg-transparent focus:outline-none placeholder:text-[#666666] text-lg py-2 resize-none h-10 overflow-hidden" placeholder="Post a new pass on..." value={message} onChange={e => setMessage(e.target.value)} rows={1} data-id="element-500" />
                <button className={`rounded-full w-12 h-12 flex items-center justify-center transition-all ${message.trim() ? 'bg-[#4a90e2] text-white hover:bg-[#3a7bc2]' : 'bg-white/5 text-[#666666]'}`} disabled={!message.trim()} data-id="element-501">
                  <SendIcon size={20} className={message.trim() ? 'text-white' : 'text-[#666666]'} data-id="element-502" />
                </button>
              </div>
            </div>

            <button className={`rounded-full w-14 h-14 flex items-center justify-center transition-all flex-shrink-0 border bg-[#151A22] border-white/5 hover:bg-white/5`} data-id="element-503">
              <MicIcon size={22} className="text-[#e0e0e0]" data-id="element-504" />
            </button>
          </div>
        </div>
      </div>
    </main>;
};